var map = {
	"./blacksmith.jpg": 1810,
	"./cathedeal.jpg": 4909,
	"./dungeon.jpg": 8164,
	"./farm.jpg": 646,
	"./island.jpg": 3758,
	"./isometricroom.jpg": 9912,
	"./livingKitchenLounge.jpg": 6729,
	"./losttemple.jpg": 2540,
	"./medievaltown.jpg": 8578,
	"./monobeigeroom.jpg": 5993,
	"./moonglowvillage.jpg": 5412,
	"./neoncity.jpg": 4089,
	"./pasteltown.jpg": 5380,
	"./rivercity.jpg": 7030,
	"./robot.png": 6960,
	"./sunnyhillvillage.jpg": 5248,
	"./sunsettrain.jpg": 9614,
	"./train.jpg": 1187,
	"./turtleship.jpg": 4364,
	"./warmdreamroom.jpg": 3822,
	"./weapon.jpg": 2062,
	"./witchscauldrun.jpg": 3503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3139;